import React, {Component} from 'react';
import Navigation from "./Navigation";
import {withModal} from "../modal";

import logo from "../assets/images/logo.svg";
import {frameRequestService, langService} from "../services/lang.service";
import {checkURL} from "./../funcs/functions";

class HeadLine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalTitle: 'First Modal',
      language: '',
      frameRender: false
    };
  }

  componentDidMount() {
    this.langSubscribe = langService.getLang().subscribe(lang => {
      this.setState({
        language: lang.lang
      });
    });

    this.frameSubscribe = frameRequestService.getFrame().subscribe(req => {
      this.setState({
        frameRender: req.frame
      })
    });
  }

  componentWillUnmount() {
    this.langSubscribe.unsubscribe();
    this.frameSubscribe.unsubscribe();
  }

  changeLanguage = (language) => {
    const category = checkURL().category ? '=?' + checkURL().category : '';
    const hashURLReplace = language + category;

    langService.setLang(language);
    localStorage.setItem('language', language);

    window.location.hash = hashURLReplace;
  };


  render() {
    const {setFilterType, filterType} = this.props;
    const {language, frameRender} = this.state;

    return (
      <div className="container">
        {frameRender
          ? null
          : <div className="row">
            <div className="m-area">
              <a className="m-logo-area"
                 href={'https://www.crocobet.com/'}
              >
                <img src={logo} alt="CROCOBET Promotions"/>
              </a>
              <div className="language-bar language-bar--mobile">
                <div className={'language ' + (language === 'ka' ? 'language--active' : '')}
                     onClick={(e) => this.changeLanguage('ka')}>KA
                </div>
                <div className={'language ' + (language === 'en' ? 'language--active' : '')}
                     onClick={(e) => this.changeLanguage('en')}>EN
                </div>
                <div className={'language ' + (language === 'ru' ? 'language--active' : '')}
                     onClick={(e) => this.changeLanguage('ru')}>RU
                </div>
              </div>
            </div>
            <div className="headline">
              <a
                href={'https://www.crocobet.com/'}
                className="logo-area">
                <img src={logo} alt="CROCOBET Promotions"/>
              </a>
              <Navigation language={language} filterType={filterType} setFilterType={setFilterType}/>
              <div className="language-bar">
                <div className={'language ' + (language === 'ka' ? 'language--active' : '')}
                     onClick={(e) => this.changeLanguage('ka')}>KA
                </div>
                <div className={'language ' + (language === 'en' ? 'language--active' : '')}
                     onClick={(e) => this.changeLanguage('en')}>EN
                </div>
                <div className={'language ' + (language === 'ru' ? 'language--active' : '')}
                     onClick={(e) => this.changeLanguage('ru')}>RU
                </div>
              </div>
            </div>
          </div>}
      </div>
    );
  }

}

export default withModal(HeadLine);
